import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {HistoryLogComponent} from './history-log.component';

export const historyLogRoutes: Routes = [
  {
    path: 'historyLog',
    component: HistoryLogComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(historyLogRoutes)],
  exports: [RouterModule]
})
export class HistoryLogRoutingModule { }



// WEBPACK FOOTER //
// /opt/app/src/app/features/history-log/history-log-routing.module.ts